// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bXlh","rootMobile":"styles_rootMobile__3nnot"};